<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="151"
    height="169"
    viewBox="0 0 151 169"
    fill="none"
  >
    <path
      d="M75.2019 135.197C106.793 135.197 132.404 109.586 132.404 77.8821C132.404 46.1785 106.68 20.5674 75.2019 20.5674C43.6111 20.5674 18 46.1785 18 77.8821C18 109.586 43.6111 135.197 75.2019 135.197Z"
      fill="#EAEEF9"
    />
    <path
      d="M140.571 114.862C143.126 114.862 145.197 112.791 145.197 110.236C145.197 107.682 143.126 105.611 140.571 105.611C138.016 105.611 135.945 107.682 135.945 110.236C135.945 112.791 138.016 114.862 140.571 114.862Z"
      fill="#D5DDEA"
    />
    <path
      d="M147.341 96.8103C149.086 96.8103 150.5 95.396 150.5 93.6513C150.5 91.9066 149.086 90.4922 147.341 90.4922C145.596 90.4922 144.182 91.9066 144.182 93.6513C144.182 95.396 145.596 96.8103 147.341 96.8103Z"
      fill="#D5DDEA"
    />
    <path
      d="M25.6598 40.1988C27.4045 40.1988 28.8189 38.7844 28.8189 37.0397C28.8189 35.295 27.4045 33.8806 25.6598 33.8806C23.9151 33.8806 22.5007 35.295 22.5007 37.0397C22.5007 38.7844 23.9151 40.1988 25.6598 40.1988Z"
      fill="#D5DDEA"
    />
    <path
      d="M6.36687 101.124C9.60705 101.124 12.2337 98.4972 12.2337 95.257C12.2337 92.0168 9.60705 89.3901 6.36687 89.3901C3.12668 89.3901 0.5 92.0168 0.5 95.257C0.5 98.4972 3.12668 101.124 6.36687 101.124Z"
      fill="#D5DDEA"
    />
    <g filter="url(#filter0_d_5061_116337)">
      <rect
        x="35.6239"
        y="103.112"
        width="81.3689"
        height="32.6581"
        rx="4"
        fill="url(#paint0_linear_5061_116337)"
      />
    </g>
    <path
      d="M47.2471 115.553H95.9231"
      stroke="#C2C8D6"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M47.2471 124.106H75.5809"
      stroke="#C2C8D6"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <g filter="url(#filter1_d_5061_116337)">
      <rect
        x="35.6239"
        y="11.23"
        width="81.3689"
        height="32.6581"
        rx="4"
        fill="url(#paint1_linear_5061_116337)"
      />
    </g>
    <path
      d="M47.2471 23.6714H95.9231"
      stroke="#C2C8D6"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M47.2471 32.2246H75.5809"
      stroke="#C2C8D6"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <g filter="url(#filter2_d_5061_116337)">
      <rect
        x="27"
        y="52.158"
        width="96.3754"
        height="42.4892"
        rx="4"
        fill="url(#paint2_linear_5061_116337)"
      />
    </g>
    <path
      d="M45.363 80.2051C40.1419 80.2051 35.965 76.0252 35.965 70.8003C35.965 65.5754 40.1419 61.3955 45.363 61.3955C50.5842 61.3955 54.7611 65.5754 54.7611 70.8003C54.7611 75.9207 50.5842 80.2051 45.363 80.2051Z"
      fill="#C2C8D6"
    />
    <path
      d="M51.0014 75.6073C49.5395 74.1443 48.182 73.3083 45.3626 73.3083C42.4387 73.3083 41.1857 74.2488 39.7238 75.6073C41.0813 77.1748 43.1697 78.2197 45.467 78.2197C47.5555 78.2197 49.4351 77.3838 50.7926 76.0253C50.7926 75.9208 51.0014 75.8163 51.0014 75.6073C51.1058 75.6073 51.0014 75.6073 51.0014 75.6073Z"
      fill="white"
    />
    <path
      d="M45.3612 71.5318C47.0913 71.5318 48.4939 70.1283 48.4939 68.3969C48.4939 66.6655 47.0913 65.262 45.3612 65.262C43.6311 65.262 42.2285 66.6655 42.2285 68.3969C42.2285 70.1283 43.6311 71.5318 45.3612 71.5318Z"
      fill="white"
    />
    <path
      d="M61.4196 73.4026H109.607"
      stroke="#C2C8D6"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M61.4196 64.7976H109.607"
      stroke="#C2C8D6"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M61.4196 82.0076H90.6764"
      stroke="#C2C8D6"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <defs>
      <filter
        id="filter0_d_5061_116337"
        x="13.6239"
        y="92.1118"
        width="125.369"
        height="76.658"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5061_116337"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5061_116337"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_5061_116337"
        x="13.6239"
        y="0.22998"
        width="125.369"
        height="76.658"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5061_116337"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5061_116337"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_5061_116337"
        x="5"
        y="41.158"
        width="140.375"
        height="86.4893"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5061_116337"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5061_116337"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_5061_116337"
        x1="76.2818"
        y1="102.356"
        x2="76.2818"
        y2="136.122"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5061_116337"
        x1="76.2818"
        y1="10.4746"
        x2="76.2818"
        y2="44.2401"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5061_116337"
        x1="75.1563"
        y1="51.1751"
        x2="75.1563"
        y2="95.1053"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup></script>
